import * as React from "react";
import { Route, Routes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Buffer } from "buffer";
import NotFound from "./pages/NotFound";
import AppContainer from "./pages/AppContainer";
import { RequireAuth } from "./utils/RequireAuth";
import routes from "./utils/Routes";
import CheckAuth from "./utils/CheckAuth";
import LoginPage from "./modules/auth/pages/Login";
import ResetPasswordPage from "./modules/auth/pages/ResetPassword";
import ScrollToTopButton from "./components/ScrollToTopButton/ScrollToTopButton";
import { DEFAULT_PRACTICE_ID } from "./utils/constants";
import { useAppSelector } from "./hooks/useRedux";
import Dashboard from "./modules/dashboard/pages/Dashboard";
import MeetingRoomPage from "./modules/meeting/pages/meeting";

window.Buffer = Buffer;

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
    const { practice } = useAppSelector((state) => state.userPractice);

    /**
     * Currently some users saved filter for the remit claims page
     * have their page filter value at a very high value so we need clear the page value from what they have
     */
    const remitClaimsListSavedFilters = localStorage.getItem(
        "remitclaimslist_filters"
    );

    if (
        remitClaimsListSavedFilters &&
        remitClaimsListSavedFilters?.includes("page")
    ) {
        const newValue = localStorage
            .getItem("remitclaimslist_filters")
            ?.split("&")
            .filter((item) => !item.includes("page"))
            .join("&");

        if (newValue) {
            localStorage.setItem("remitclaimslist_filters", newValue);
        } else localStorage.removeItem("remitclaimslist_filters");
    }

    /**
     * JULY 10 2024 - Update current pinned clients in local storage
     * We are using this to update the currently stored pinned clients in local storage key to
     * the new format for the key. `from "pinned_clients" to `pinned_clients_${practice_id}`
     */

    if (DEFAULT_PRACTICE_ID === practice?.practice_id) {
        const previousPins = localStorage.getItem("pinned_clients");

        if (previousPins) {
            localStorage.setItem(
                `pinned_clients_${practice?.practice_id}`,
                previousPins
            );

            localStorage.removeItem("pinned_clients");
        }
    }

    return (
        <SentryRoutes>
            <Route
                path="/"
                element={
                    <RequireAuth>
                        <>
                            <AppContainer />
                            <ScrollToTopButton />
                        </>
                    </RequireAuth>
                }
            >
                <Route index element={<Dashboard />} />
                {routes.map((item) => (
                    <Route
                        key={item.path}
                        path={item.path}
                        element={<item.component />}
                    />
                ))}
            </Route>
            <Route
                path="/meeting/:sessionHistoryId/join"
                element={
                    <RequireAuth>
                        <MeetingRoomPage />
                    </RequireAuth>
                }
            />
            <Route
                path="login"
                element={
                    <CheckAuth>
                        <LoginPage />
                    </CheckAuth>
                }
            />
            <Route
                path="reset-password"
                element={
                    <CheckAuth>
                        <ResetPasswordPage />
                    </CheckAuth>
                }
            />
            <Route path="*" element={<NotFound />} />
        </SentryRoutes>
    );
}

export default App;
